import { Component, OnInit, OnDestroy } from '@angular/core';

import { Tba, TbaValidationErrorResponse, TbaEvaluationMethod, TransactionType } from '../../../shared/models';

import {
  ConfirmationModalComponent } from '../../../shared/components/confirmation-modal/confirmation-modal.component';
import {
  ClosableModalWithErrorResponseModel
} from '../../../shared/components/base/closable-modal-with-error-response-model';

import {
  TbasService, TbaEvaluationMethodsService, NotificationService, SessionService } from '../../../shared/services';
import { ModalService } from '../../../shared/modules/modal';

@Component({
  selector: 'tba-modal',
  templateUrl: './tba-modal.component.html',
})
export class TbaModalComponent
  extends ClosableModalWithErrorResponseModel<TbaValidationErrorResponse>
  implements OnInit, OnDestroy {

  data: any = {};
  tba: Tba;
  lockedFields: string[] = [];
  tbaMethods: TbaEvaluationMethod[];
  transactionTypes: TransactionType[];

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _tbasService: TbasService,
    private _tbaEvaluationMethodsService: TbaEvaluationMethodsService,
    private _sessionService: SessionService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new TbaValidationErrorResponse();
  }

  ngOnInit() {
    this.tba = new Tba();
    if (this.data.study) {
      this.tba.study = this.data.study;
      this.tba.primaryLegalEntity = this.data.study.primaryEntity;
    }
    this.tba.container = this._sessionService.getWorkingContainer();
    this.getTbaEvaluationMethods();
    if (!!this.data.tbaId && this.data.tbaId > 0) {
      this.getTba(this.data.tbaId);
    }
    this.listenForErrorMessages();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  getTbaEvaluationMethods(): void {
    this._tbaEvaluationMethodsService.list().subscribe((res) => {
      this.tbaMethods = res.result.methods;
      this.transactionTypes = this.tbaMethods[0].transactionTypes;

      this.transactionTypes.sort((type1, type2) => {
        return type1.name > type2.name ? 1 : -1;
      });
    });
  }

  filterTransactionTypes(methodId: number): void {
    const data = this.tbaMethods.find(method => method.tbaEvaluationMethodId === methodId);
    if (!data) {
      this.transactionTypes = this.tbaMethods[0].transactionTypes;
      return;
    }
    this.transactionTypes = data.transactionTypes;

    this.transactionTypes.sort((type1, type2) => {
      return type1.name > type2.name ? 1 : -1;
    });
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.responseErrors = [];
    if (!this.data.tbaId) {
      this.create();
    } else {
      this.edit(this.data.tbaId);
    }
  }

  close(form = null): void {
    if (form && form.form.touched) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: 'Close Tba',
          content: 'Are you sure you want to cancel your actions and close it?',
        },
        success: () => {
          this.closeAllModals();
        },
      });
    } else {
      this.closeAllModals();
    }
  }

  private create(): void {
    this._tbasService.save(this.tba).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  private edit(tbaId: number): void {
    const payload = this.getModelForSave();

    this._tbasService.edit(tbaId, payload).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  private getModelForSave(): Tba {
    const tba = new Tba();
    Object.assign(tba, this.tba);
    if (!!this.lockedFields && this.lockedFields.length > 0) {
      delete tba.transactionType;
      delete tba.tbaEvaluationMethod;
    }

    return tba;
  }

  private getTba(tbaId: number): void {
    this._tbasService.show(tbaId).subscribe((res) => {
      this.tba = res.result.tba;
      this.lockedFields = res.result.locked;
      this.filterTransactionTypes(this.tba.tbaEvaluationMethod.tbaEvaluationMethodId);
    });
  }
}
